import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import ChevronDown from "../../icons/ChevronDown";
import { getSize } from "../../Icon";
import { ICON_SIZES } from "../../Icon/consts";
import media from "../../utils/mediaQuery";
import CardSectionContext from "./CardSectionContext";
var StyledCardSectionIconRight = styled(ChevronDown).withConfig({
  displayName: "CardSection__StyledCardSectionIconRight",
  componentId: "o8zdxr-0"
})(["align-self:center;transition:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.durationFast;
});
StyledCardSectionIconRight.defaultProps = {
  theme: defaultTheme
};
var StyledCardSectionContent = styled.div.withConfig({
  displayName: "CardSection__StyledCardSectionContent",
  componentId: "o8zdxr-1"
})(["font-family:", ";font-size:", ";line-height:", ";color:", ";border-top:", ";padding-top:", ";overflow:hidden;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.lineHeightTextNormal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.colorTextPrimary;
}, function (_ref6) {
  var theme = _ref6.theme,
      expanded = _ref6.expanded;
  return expanded ? "1px solid ".concat(theme.orbit.paletteCloudNormal) : "0px solid ".concat(theme.orbit.paletteCloudNormal);
}, function (_ref7) {
  var theme = _ref7.theme,
      expanded = _ref7.expanded;
  return expanded && "".concat(theme.orbit.spaceMedium);
});
StyledCardSectionContent.defaultProps = {
  theme: defaultTheme
};
export var StyledCardSection = styled.div.withConfig({
  displayName: "CardSection__StyledCardSection",
  componentId: "o8zdxr-2"
})(["width:100%;padding:", ";box-sizing:border-box;position:relative;background:", ";", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.spaceMedium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.orbit.backgroundCard;
}, media.desktop(css(["padding:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.spaceLarge;
})));
StyledCardSection.defaultProps = {
  theme: defaultTheme
};
var StyledCardSectionHeader = styled.div.withConfig({
  displayName: "CardSection__StyledCardSectionHeader",
  componentId: "o8zdxr-3"
})(["margin-bottom:", ";display:flex;flex-direction:row;cursor:pointer;position:relative;min-height:", ";"], function (_ref11) {
  var theme = _ref11.theme,
      expanded = _ref11.expanded;
  return expanded && theme.orbit.spaceMedium;
}, function (_ref12) {
  var expandable = _ref12.expandable;
  return expandable && getSize(ICON_SIZES.MEDIUM);
});
StyledCardSectionHeader.defaultProps = {
  theme: defaultTheme
};

var CardSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CardSection, _React$Component);

  function CardSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "injectCallbackAndToggleSection", function () {
      var _this$props = _this.props,
          handleToggleSection = _this$props.handleToggleSection,
          onClose = _this$props.onClose,
          onExpand = _this$props.onExpand,
          expanded = _this$props.expanded;
      handleToggleSection(); // First do toggle

      if (expanded && onClose) {
        // If is expanded -> action is closing
        onClose();
      }

      if (!expanded && onExpand) {
        // if is closed > action is expanding
        onExpand();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (ev) {
      if (ev.keyCode === 13 || ev.keyCode === 32) {
        ev.preventDefault();

        _this.injectCallbackAndToggleSection();
      }
    });

    return _this;
  }

  _createClass(CardSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          handleToggleSection = _this$props2.handleToggleSection,
          initialExpanded = _this$props2.initialExpanded,
          setInitialExpandedSection = _this$props2.setInitialExpandedSection;

      if (initialExpanded) {
        handleToggleSection();
        setInitialExpandedSection();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          dataTest = _this$props3.dataTest,
          expandable = _this$props3.expandable,
          expanded = _this$props3.expanded;
      return React.createElement(StyledCardSection, {
        "data-test": dataTest,
        expandable: expandable,
        expanded: expanded
      }, React.createElement(CardSectionContext.Provider, {
        value: {
          expandable: expandable,
          expanded: expanded,
          handleToggleSection: this.injectCallbackAndToggleSection,
          onKeyDownHandler: this.handleKeyDown
        }
      }, children));
    }
  }]);

  return CardSection;
}(React.Component);

export default CardSection;
export { default as CardSectionHeader } from "./CardSectionHeader";
export { default as CardSectionContent } from "./CardSectionContent";